<template>
  <Transition name="slide-fade">
    <form class="p-3 mb-4 border shadow-sm rounded" v-if="showCancel">
      <div class="form-group">
        <label for="reason">What is your reason for cancelling this booking?</label>
        <textarea class="form-control" id="reason" rows="5" v-model="cancellation_reason"></textarea>
      </div>
      <div class="my-3">
        <p class="m-0">
          <input id="checkbox" type="checkbox" value="" class="mr-2"
          v-model='$v.acceptedterm.$model' />I have read the <a href="#terms">cancellation policies</a> and do accept the terms and conditions
        </p>
        <div class="" v-if='$v.acceptedterm.$error' :class='{ "form__input-error": $v.acceptedterm.$error }'>
          Please accept the cancellation policy before proceeding
        </div>
      </div>
      <div class="d-flex justify-items-center justify-content-between mb-3">
        <button
          class="save btn"
          type="button" @click.prevent="cancelBookingLocal()">
          Submit
        </button>
      </div>
    </form>
  </Transition>
</template>

<script>
import manageBooking from '../../mixins/manageBooking'
import reusableData from '../../mixins/reusableData'
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    showCancel: Boolean
  },
  data () {
    return {
      cancellation_reason: '',
      acceptedterm: '',
      bookingCancelled: this.$store.state.bookingCancelled
    }
  },
  validations: {
    acceptedterm: { required }
  },
  methods: {
    cancelBookingLocal () {
      this.$v.$touch()
      if (this.acceptedterm === true) {
        this.$confirm('This action cannot be reversed, do you want to proceed?', 'Cancellation', 'warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          this.getUrlData()
          this.cancelBooking()
        })
      } else {
        this.$alert('Please accept the cancellation policy before proceeding.', '',
          'warning')
      }
    }
  },
  mixins: [manageBooking, reusableData]
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/manageBooking/subcomponents/CancelBooking.vue